import axios from 'axios';
import { MarketId } from 'types/market-id.enum';
import { SmoltType } from 'views/planning-prognosis/features/view-fish-group/types/smolt-type.type';

// GET
// /ewosapi/v1/planandprognosis/smolttype/market/{marketId}
export const getSmoltType = async (marketId: MarketId): Promise<SmoltType[]> => {
  const res = await axios.get<SmoltType[]>(`/ewosapi/v1/planandprognosis/smolttype/market/${marketId}`);
  return res.data;
};
